<template>
	<header class="main-header">
        <!-- <a :href="config.redirect_url" class="logo-holder"><img src="@/assets/img/logo.png" alt=""></a> -->
		<router-link to="/" class="logo-holder"><img src="@/assets/img/logo.svg" alt=""></router-link>
        <div class="show-web">
            <a @click="logout()" class="add-list"><span><i class="material-icons" style="margin-top:-3px">logout</i></span> {{translate(locale.logout)}}</a>
            <button class="theme-toggle" type="button" :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'" :title="isDark ? 'Light mode' : 'Dark mode'" @click="toggleTheme">
                <i class="material-icons">{{ isDark ? 'light_mode' : 'dark_mode' }}</i>
            </button>
        </div>
        <div class="show-mobile">
            <a @click="$sidebar.showSidebar = !$sidebar.showSidebar" class="add-list"><span style="margin-right: 0px"><i class="material-icons" style="margin-top:-3px">dehaze</i></span></a>
            <a @click="logout()" class="add-list" style="margin-right: 5px"><span style="margin-right: 0px;"><i class="material-icons" style="margin-top:-3px">logout</i></span></a>   
            <button class="theme-toggle" type="button" :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'" @click="toggleTheme">
                <i class="material-icons">{{ isDark ? 'light_mode' : 'dark_mode' }}</i>
            </button>
        </div>
    </header>
</template>
<script>
	export default {
		name: 'loading',
		data() {
			return {
				isDark: false
			}
		},
		created() {
			const savedTheme = window.localStorage.getItem('sabayflix-theme')
			// Light is the default for first-time users; an explicit choice wins.
			this.isDark = savedTheme ? savedTheme === 'dark' : false
			this.applyTheme()
		},
		methods: {
            applyTheme() {
                window.document.documentElement.setAttribute('data-theme', this.isDark ? 'dark' : 'light')
            },
            toggleTheme() {
                this.isDark = !this.isDark
                window.localStorage.setItem('sabayflix-theme', this.isDark ? 'dark' : 'light')
                this.applyTheme()
            },
            logout() {
				this.$store.state.authentication.loggedIn = false;
				this.$store.state.authentication.authToken = null;
				this.$cookie.delete("auth");
			},
			language(code) {
				this.$store.state.l.lang = code;
				this.$cookie.set('lang', code, 10);
				window.document.title = this.translate(this.locale.headTitle);
			}
		}
	}
</script>

<style scoped>
.main-header {
	position:fixed;
	width:100%;
	left:0;
	top:0;
	height:68px;
	background:#0a0e1a;
	z-index:31;
	padding:0 32px 0 12px;
    z-index: 80;
}
@media (max-width: 991px) {
    .main-header {
        padding: 0 16px;
    }
}

.dsh-header.main-header:before {
	width:540px;
}
.main-header.vis-searchdec:before {
	opacity:0;
}
.logo-holder {
	float:left;
	height:42px;
	position:relative;
	top:13px;
	left: 13px
}
.logo-holder img {
	width:auto;
	height:100%;
}
.add-list {
    background:#e00000;
	float:right;
	padding: 0 10px;
	position:relative;
	height:40px;
	top:14px;
	line-height:40px;
	border-radius:4px;
	color:#fff !important;
    cursor: pointer;
	font-weight:600;
	font-size:13px;
	font-family: "Open Sans", "Hanuman", sans-serif;
    transition: all .2s ease-in-out;
}

.add-list span {
	color:#fff;
	padding-right:3px;
}
.theme-toggle {
    position: relative;
    top: 16px;
    float: right;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    padding: 0;
    border: 1px solid rgba(148, 163, 184, .25);
    border-radius: 12px;
    color: #d9e1ed;
    background: rgba(255, 255, 255, .055);
    cursor: pointer;
    transition: transform .2s ease, border-color .2s ease, background .2s ease;
}
.theme-toggle:hover {
    border-color: rgba(255, 102, 116, .55);
    background: rgba(255, 51, 71, .09);
    transform: translateY(-2px);
}
.theme-toggle i { font-size: 20px; }
@media (max-width: 991px) {
    .theme-toggle { top: 13px; margin-right: 5px; }
}
.cart-btn  {
	float: right;
	position:relative;
	color:#fff;
	cursor:pointer;
	margin-right:34px;
	top:28px;
	font-size:18px;
}
.cart-btn i {
	width:12px;
}
.cart-counter {
	position:absolute;
	bottom:-1px;
	width:14px;
	height:14px;
	line-height:14px;
	border-radius:100%;
	color:#fff;
	left:-5px;
	z-index:2;
	font-size:8px;
	font-weight:400;
}
.show-reg-form {
    float: right;
    color: #fff;
    cursor: pointer;
    margin-right: 40px;
    position: relative;
    top: 32px;
	font-weight:500;
    font-size: 12px;
}
.show-reg-form:before {
	content:'';
	position:absolute;
	left:-25px;
	top:50%;
	height:20px;
	margin-top:-10px;
	width:1px;
	background:rgba(255,255,255,0.31);
}
.show-reg-form i {
	margin-right:14px;
}
.lang-wrap  {
	float: right;
	margin-right:20px;
	position:relative;
	top:20px;
}
.lang-tooltip {
	position:absolute;
	top:0px;
	right:0;
	width:100px;
	z-index:105;
	background:#fff;
	padding:10px 0 12px;
	border-radius:4px;
	border:1px solid #eee;
	border-top:none;
	visibility:hidden;
	opacity:0;
}
.show-lang   {
	color:#fff;
	cursor:pointer;
	float:right;
	padding: 7px 0;
	position:relative;
	font-size:13px;
	border:1px solid transparent;
}
.show-lang i.arrlan {
	position:absolute;
	top:50%;
	line-height:10px;
	height:10px;
	margin-top:-7px;
	margin-left:5px;
	color:#fff;
}
.show-lang span {
	position:relative;
	z-index:2;
	float:left;
	margin-left:10px;
}
.show-lang span strong {
	padding-left:10px;
	top:-2px;
	font-weight:500;
	position:relative;
}
.show-lang span i {
	font-size:17px;
}
.show-lang .fa-angle-down {
	position:relative;
	top:2px;
}
.lang-wrap:hover .lang-tooltip  {
	visibility:visible;
	opacity:1;
}
.no-list-style {
	list-style:none;
}
.lang-tooltip li  {
	float:left;
	width:100%;
	position:relative;
	text-align:left;
	color:#fff;
	border-radius:4px;
	padding:6px 14px;
}
.lang-tooltip li a  {
	color: #566985;
	font-weight:500;
	font-size:13px;
	position:relative;
	float:left;
    cursor: pointer;
	width:100%;
}
.lang-tooltip li a:before {
	font-family: Font Awesome\ 5 Pro;
	content: "\f00c";
	position:absolute;
	right:0;
	top:0;
	opacity:0;
}
.lang-tooltip li a.current-lan:before {
	opacity:1;
}
.header-user-menu {
	float:right;
	position:relative;
	top:20px;
	margin-left:50px;
	margin-right:40px;
}
.header-user-menu:after {
	content:'';
	position:absolute;
	left:-70px;
	height:30px;
	top:4px;
	width:1px;
	background:rgba(255,255,255,0.21);
}
.header-user-name {
	position:relative;
	float:left;
	cursor:pointer;
	color:#fff;
	transition: 0.2s;
    white-space: nowrap;
    text-overflow: ellipsis;
	padding-top:10px;
	font-weight:600;
}
.header-user-name:before {
	font-family: Font Awesome\ 5 Pro;
	content: "\f0d7";
	position:absolute;
	color:#fff;
	bottom:1px;
	font-size:13px;
	right:-16px;
	transition: all .2s ease-in-out;
}
.header-user-name span {
	position:absolute;
	width:38px;
	height:38px;
	border-radius:100%;
	overflow:hidden;
	top:0;
	left:-50px;
}
.header-user-name span img {
	width:100%;
	height:100%;
}
.header-user-menu ul {
	margin: 10px 0 0 0;
    opacity: 0;
	list-style:none;
    visibility: hidden;
    position: absolute;
    min-width: 150px;
    top: 60px;
    left: -50px;
    z-index: 1;
    padding: 10px 0;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #eee;
    transition: all .2s ease-in-out;
}
.header-user-name.hu-menu-visdec:before {
    transform: rotateX(180deg);
}
.header-user-menu ul.hu-menu-vis {
	opacity: 1;
    visibility: visible;
	 top: 40px;
}
.header-user-menu ul li {
	float:left;
	width:100%;
	padding:4px 0;
}
.header-user-menu ul li a {
    color: #50596E;
    float: left;
    width: 100%;
    font-weight: 500;
    text-align: left;
    padding: 6px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue